import { render, staticRenderFns } from "./scroll-wrap.vue?vue&type=template&id=fac2be96&scoped=true&"
import script from "./scroll-wrap.vue?vue&type=script&lang=js&"
export * from "./scroll-wrap.vue?vue&type=script&lang=js&"
import style0 from "./scroll-wrap.vue?vue&type=style&index=0&id=fac2be96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac2be96",
  null
  
)

export default component.exports